import React, { useCallback, useEffect, memo } from "react";
import { ScrollMorePopup } from "./ScrollMorePopup";
import { metricsBus } from "@/common/buses";

interface IScrollMorePopupContainerProps {
  onCloseScrollMore: () => void;
}

export const ScrollMorePopupContainer: React.FC<IScrollMorePopupContainerProps> = memo(({
  onCloseScrollMore
}) => {
  useEffect(() => {
    metricsBus.emit("scrollPromptViewed");
  }, []);

  const onCloseScrollMoreSendMetric = useCallback(() => {
    onCloseScrollMore();
    metricsBus.emit("scrollPromptClosed");
  }, [onCloseScrollMore]);

  return (
    <ScrollMorePopup onCloseScrollMore={onCloseScrollMoreSendMetric} />
  );
});
